var render, staticRenderFns
import script from "./addTemplateForm.vue?vue&type=script&lang=js"
export * from "./addTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f78269",
  null
  
)

export default component.exports